function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmartphone = function SvgSmartphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "937pt",
    viewBox: "-93 0 937 937.5",
    width: "937pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 608.820312 363.484375 L 587.75 386.515625 L 683.574219 474.359375 C 706.132812 495.113281 718.992188 524.355469 719 555 L 719 937.5 L 750.25 937.5 L 750.25 555 C 750.210938 515.585938 733.679688 478 704.65625 451.324219 Z M 608.820312 363.484375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 484.625 0 L 78.375 0 C 35.25 0.0546875 0.304688 35 0.25 78.125 L 0.25 859.375 C 0.304688 902.5 35.25 937.445312 78.375 937.5 L 469 937.5 L 469 909.546875 C 468.925781 839.160156 489.761719 770.320312 528.875 711.796875 C 533.015625 705.59375 532.183594 697.339844 526.921875 692.078125 L 417.546875 582.703125 C 407.4375 572.582031 402.078125 558.664062 402.785156 544.378906 C 403.496094 530.085938 410.210938 516.773438 421.265625 507.703125 C 442.558594 491.425781 472.671875 493.75 491.21875 513.089844 L 645.453125 667.328125 L 667.546875 645.234375 L 562.75 540.40625 L 562.75 78.125 C 562.695312 35 527.75 0.0546875 484.625 0 Z M 531.5 509.15625 L 513.3125 490.96875 C 483.335938 460.34375 435.125 457.152344 401.375 483.570312 C 383.523438 498.242188 372.691406 519.78125 371.5625 542.871094 C 370.4375 565.957031 379.109375 588.445312 395.453125 604.796875 L 495.921875 705.269531 C 458.453125 765.648438 438.359375 835.195312 437.859375 906.25 L 78.375 906.25 C 52.492188 906.25 31.5 885.257812 31.5 859.375 L 31.5 812.5 L 422.125 812.5 L 422.125 781.25 L 31.5 781.25 L 31.5 125 L 531.5 125 Z M 531.5 93.75 L 31.5 93.75 L 31.5 78.125 C 31.5 52.242188 52.492188 31.25 78.375 31.25 L 484.625 31.25 C 510.507812 31.25 531.5 52.242188 531.5 78.125 Z M 531.5 93.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 94 281.25 L 156.5 281.25 C 173.761719 281.25 187.75 267.261719 187.75 250 L 187.75 187.5 C 187.75 170.238281 173.761719 156.25 156.5 156.25 L 94 156.25 C 76.738281 156.25 62.75 170.238281 62.75 187.5 L 62.75 250 C 62.75 267.261719 76.738281 281.25 94 281.25 Z M 94 187.5 L 156.5 187.5 L 156.5 250 L 94 250 Z M 94 187.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.25 281.25 L 312.75 281.25 C 330.011719 281.25 344 267.261719 344 250 L 344 187.5 C 344 170.238281 330.011719 156.25 312.75 156.25 L 250.25 156.25 C 232.988281 156.25 219 170.238281 219 187.5 L 219 250 C 219 267.261719 232.988281 281.25 250.25 281.25 Z M 250.25 187.5 L 312.75 187.5 L 312.75 250 L 250.25 250 Z M 250.25 187.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.5 281.25 L 469 281.25 C 486.261719 281.25 500.25 267.261719 500.25 250 L 500.25 187.5 C 500.25 170.238281 486.261719 156.25 469 156.25 L 406.5 156.25 C 389.238281 156.25 375.25 170.238281 375.25 187.5 L 375.25 250 C 375.25 267.261719 389.238281 281.25 406.5 281.25 Z M 406.5 187.5 L 469 187.5 L 469 250 L 406.5 250 Z M 406.5 187.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 94 437.5 L 156.5 437.5 C 173.761719 437.5 187.75 423.511719 187.75 406.25 L 187.75 343.75 C 187.75 326.488281 173.761719 312.5 156.5 312.5 L 94 312.5 C 76.738281 312.5 62.75 326.488281 62.75 343.75 L 62.75 406.25 C 62.75 423.511719 76.738281 437.5 94 437.5 Z M 94 343.75 L 156.5 343.75 L 156.5 406.25 L 94 406.25 Z M 94 343.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 94 593.75 L 156.5 593.75 C 173.761719 593.75 187.75 579.761719 187.75 562.5 L 187.75 500 C 187.75 482.738281 173.761719 468.75 156.5 468.75 L 94 468.75 C 76.738281 468.75 62.75 482.738281 62.75 500 L 62.75 562.5 C 62.75 579.761719 76.738281 593.75 94 593.75 Z M 94 500 L 156.5 500 L 156.5 562.5 L 94 562.5 Z M 94 500 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.25 437.5 L 312.75 437.5 C 330.011719 437.5 344 423.511719 344 406.25 L 344 343.75 C 344 326.488281 330.011719 312.5 312.75 312.5 L 250.25 312.5 C 232.988281 312.5 219 326.488281 219 343.75 L 219 406.25 C 219 423.511719 232.988281 437.5 250.25 437.5 Z M 250.25 343.75 L 312.75 343.75 L 312.75 406.25 L 250.25 406.25 Z M 250.25 343.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.5 437.5 L 469 437.5 C 486.261719 437.5 500.25 423.511719 500.25 406.25 L 500.25 343.75 C 500.25 326.488281 486.261719 312.5 469 312.5 L 406.5 312.5 C 389.238281 312.5 375.25 326.488281 375.25 343.75 L 375.25 406.25 C 375.25 423.511719 389.238281 437.5 406.5 437.5 Z M 406.5 343.75 L 469 343.75 L 469 406.25 L 406.5 406.25 Z M 406.5 343.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.25 593.75 L 312.75 593.75 C 330.011719 593.75 344 579.761719 344 562.5 L 344 500 C 344 482.738281 330.011719 468.75 312.75 468.75 L 250.25 468.75 C 232.988281 468.75 219 482.738281 219 500 L 219 562.5 C 219 579.761719 232.988281 593.75 250.25 593.75 Z M 250.25 500 L 312.75 500 L 312.75 562.5 L 250.25 562.5 Z M 250.25 500 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 94 750 L 156.5 750 C 173.761719 750 187.75 736.011719 187.75 718.75 L 187.75 656.25 C 187.75 638.988281 173.761719 625 156.5 625 L 94 625 C 76.738281 625 62.75 638.988281 62.75 656.25 L 62.75 718.75 C 62.75 736.011719 76.738281 750 94 750 Z M 94 656.25 L 156.5 656.25 L 156.5 718.75 L 94 718.75 Z M 94 656.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.25 750 L 312.75 750 C 330.011719 750 344 736.011719 344 718.75 L 344 656.25 C 344 638.988281 330.011719 625 312.75 625 L 250.25 625 C 232.988281 625 219 638.988281 219 656.25 L 219 718.75 C 219 736.011719 232.988281 750 250.25 750 Z M 250.25 656.25 L 312.75 656.25 L 312.75 718.75 L 250.25 718.75 Z M 250.25 656.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265.875 843.75 L 297.125 843.75 L 297.125 875 L 265.875 875 Z M 265.875 843.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smartphone.4504fc57.svg";
export { ForwardRef as ReactComponent };